/* pt-motion.js v07.2 - scroll reveal + add-to-cart confirmation. No libraries. */
(function () {
  'use strict';
  window.__ptMotion = 1;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    root.classList.add('pt-rv-off');
    var all = document.querySelectorAll('main > .shopify-section, main .card');
    for (var i = 0; i < all.length; i++) all[i].classList.add('pt-in', 'pt-done');
  }

  /* ---- reveal ---- */
  function initReveal() {
    if (reduce) { revealAll(); return; }
    var main = document.getElementById('main');
    if (!main || !('IntersectionObserver' in window)) { revealAll(); return; }
    var targets = [];
    var secs = main.querySelectorAll(':scope > .shopify-section');
    for (var s = 1; s < secs.length; s++) {
      var sec = secs[s];
      var cards = sec.querySelectorAll('.card');
      if (cards.length) {
        /* stagger within a visual row: index among cards sharing the same top, capped */
        var rowTop = null, idx = 0;
        for (var c = 0; c < cards.length; c++) {
          var key = cards[c].offsetTop;
          if (key !== rowTop) { rowTop = key; idx = 0; } else { idx++; }
          cards[c].style.setProperty('--pt-i', Math.min(idx, 6));
          targets.push(cards[c]);
        }
      } else if (!sec.querySelector('.hl, .lineup-hero, .section--announcement')) {
        targets.push(sec);
      }
    }
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target, false); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (t) {
      var r = t.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) { show(t, true); } else { io.observe(t); }
    });
  }
  function show(el, instant) {
    if (instant) { el.classList.add('pt-instant', 'pt-in', 'pt-done'); return; }
    var finished = false;
    function finish() { if (finished) return; finished = true; el.removeEventListener('transitionend', done); el.classList.add('pt-done'); }
    function done(ev) { if (ev.target === el && ev.propertyName === 'opacity') finish(); }
    el.addEventListener('transitionend', done);
    el.classList.add('pt-in');
    /* pt-done only after the transition has really ended; this timer is a last resort (transitionend never fires if the element is hidden) and is longer than 450ms + the 6-step stagger */
    setTimeout(finish, 1500);
  }

  /* ---- add-to-cart confirmation: theme.js dispatches pt:cart:updated after a successful add ---- */
  var pending = null, pendingAt = 0, resetTimer = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-add-to-cart], [data-sticky-add]');
    if (b && !b.disabled) { pending = b; pendingAt = Date.now(); }
  }, true);
  document.addEventListener('pt:cart:updated', function () {
    if (!pending || Date.now() - pendingAt > 10000) { pending = null; return; }
    var b = pending; pending = null;
    b.setAttribute('data-pt-added', 'Added');
    b.classList.add('is-added');
    clearTimeout(resetTimer);
    resetTimer = setTimeout(function () { b.classList.remove('is-added'); b.removeAttribute('data-pt-added'); }, 1200);
  });

  function boot() { try { initReveal(); } catch (err) { revealAll(); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
